import React, { useContext } from 'react'
import { DepartmentIcon, Logo } from '@deal/components'
import { DepartmentContext } from '#src/context/department'
import { UserAgentContext } from '#src/containers/UserAgent'
import useReactRouter from 'use-react-router'
import { NavLink } from 'react-router-dom'
import { isConsumerMobileNative } from '#src/services/mobile'
import ChevronLeftIcon from './chevron-left.svg'
import BrandAwareLogo from '#src/components/Logo'
import GradientMask from './gradient-mask.svg'
import styles from './styles.css'

interface LogoProps {}

const HeaderLogo: React.SFC<LogoProps> = () => {
  const { history } = useReactRouter()
  const userAgent = useContext(UserAgentContext)
  const { department } = useContext(DepartmentContext)

  return (
    <>
      <GradientMask className={styles.departmentIconGradient} />
      {isConsumerMobileNative(userAgent) && (
        <div className={styles.backButtonWrapper}>
          <ChevronLeftIcon onClick={() => history.goBack()} className={styles.backButton} />
        </div>
      )}
      <NavLink to={department ? `/d/${department.slug}` : '/'} className={styles.link}>
        {!isConsumerMobileNative(userAgent) && department ? (
          <DepartmentIcon departmentSlug={department.slug} className={styles.departmentIcon} />
        ) : (
          <Logo className={styles.logoIcon} mark="icon" />
        )}

        <div className={styles.stack}>
          <BrandAwareLogo color="dark" className={styles.wordmark} />
          {department && <div className={styles.departmentName}>{department.displayName}</div>}
        </div>
      </NavLink>
    </>
  )
}

export default HeaderLogo
